import { ca } from '@cian/analytics';
import { FSK_SP_NAME, FSK_SP_LINK_SECTIONS } from '../../constants/specialProjects/fskSpecialProject';
import { getCianAnalyticsObject } from './getCianAnaliticsObject';

export function trackingShowFSKLink(section?: string) {
  if (!section || !FSK_SP_LINK_SECTIONS.includes(section)) {
    return;
  }

  const isSale = section === 'sale';
  const action = isSale ? 'show_top_menu_sale' : 'show_top_menu_newobjects';
  const category = isSale ? 'main_sale' : 'main_newobjects';
  const { page, user } = getCianAnalyticsObject();

  ca('eventSite', {
    name: 'soprevent',
    category,
    action,
    label: FSK_SP_NAME,
    page,
    user,
  });
}

export function trackingClickFSKLink(section?: string) {
  if (!section || !FSK_SP_LINK_SECTIONS.includes(section)) {
    return;
  }

  const isSale = section === 'sale';
  const action = isSale ? 'top_menu_sale' : 'top_menu_newobjects';
  const category = isSale ? 'main_sale' : 'main_newobjects';
  const { page, user } = getCianAnalyticsObject();

  ca('eventSite', {
    name: 'oldevent',
    category,
    action,
    label: FSK_SP_NAME,
    page,
    user,
  });
}
